import * as React from "react";
const SvgFiRrMessageQuestion = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-message-question_svg__a)">
      <path
        fill="#062147"
        d="M20 0H4C1.794 0 0 1.794 0 4v12c0 2.206 1.794 4 4 4h2.923l3.749 3.156c.382.34.861.509 1.337.508.468 0 .931-.162 1.292-.484L17.148 20h2.853c2.206 0 4-1.794 4-4V4c0-2.206-1.795-4-4.001-4m2 16c0 1.103-.897 2-2 2h-3.212c-.232 0-.458.081-.637.229l-4.171 3.415-4.048-3.409A1 1 0 0 0 7.287 18H3.999c-1.103 0-2-.897-2-2V4c0-1.103.897-2 2-2h16c1.103 0 2 .897 2 2zm-8.5.5a1.5 1.5 0 1 1-3.001-.001 1.5 1.5 0 0 1 3.001.001m2.364-9.549c.49 1.898-.429 3.867-2.186 4.68-.239.111-.679.64-.679 1.169v.2a1 1 0 1 1-2 0v-.2c0-1.384.947-2.57 1.838-2.983a2.01 2.01 0 0 0 1.091-2.365 1.97 1.97 0 0 0-1.379-1.379c-.643-.169-1.271-.043-1.772.345A1.99 1.99 0 0 0 10 8.001a1 1 0 1 1-2 0c0-1.247.565-2.4 1.553-3.164a4.01 4.01 0 0 1 3.497-.7 3.97 3.97 0 0 1 2.814 2.814"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-message-question_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMessageQuestion;
